// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import { mergeClasses } from 'util/commons';
import './Modal.scss';

export type ModalProps = {
  children?: React.ReactNode;
  buttonType?: 'default' | 'white';
  isSmall?: boolean;
  style?: React.CSSProperties;
  className?: string;
  contentClassName?: string;
  centered?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

export const Modal = ({
  isSmall,
  children,
  style,
  className,
  contentClassName,
  centered,
  onClick,
}: ModalProps) => {
  return (
    <div
      className={mergeClasses('modal', className)}
      style={style}
      onClick={onClick}
    >
      <div
        className={mergeClasses('contents', contentClassName, {
          'small-modal': isSmall,
          'centered-modal': centered,
        })}
      >
        {children}
      </div>
    </div>
  );
};
